import React from 'react';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import LiveChatAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/LiveChatAppIcon';

const ChatOnYourWebsiteStrategy = {
  previewInfo: {
    name: 'Chat on your website',
    iconSvg: <LiveChatAppIcon size="xlarge" />,
    newTab: false,
  },
  headerInfo: {
    name: 'Add chat to your website',
    category: 'Convert website visitors to customers',
    details: (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography paragraph>
            Want to add your very own Blue Chat Bubble on your website so that customers
            can message you right when they are on your website? Well now you can!
          </Typography>
          <Typography paragraph>
            Simply take the following steps and you’ll get set up in no time:
          </Typography>
          <ol>
            <li>Choose the color of your chat bubble using the color picker on the right.</li>
            <li>
              Copy the javascript snippet to the right.
              <ol type="a">
                <li style={{ fontWeight: 'bold' }}>
                  Do not
                  {' '}
                  <Typography style={{ fontWeight: 'normal', display: 'inline' }}>
                    share this snippet with anyone. This is only for your company.
                  </Typography>
                </li>
              </ol>
            </li>
            <li>Paste the snippet into the header of the HTML in your website</li>
            <li>Publish the changes</li>
            <li>Your chat bubble should appear at the bottom right corner of your website</li>
            <li>
              If you have any issues, contact your website provider help desk
              and they should be able to walk you through how to do this.
            </li>
          </ol>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>
            How does a customer contact me through the chat bubble?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography paragraph>
            Once the customer enters their name into the chat bubble they will be able to message you.
            Once they message you, you will get a message in your “Customers” workspace.
            From there, you can chat like you would any other customer.
            Your customer can also send you images, videos and files directly from your website,
            making diagnosing the problem even easier.
          </Typography>
        </Grid>
      </Grid>
    ),
    iconSvg: <LiveChatAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/uv8rzotpec?videoFoam=true%22&autoPlay=false',
  },
  sellingPoints: {},
  price: {
    hideCard: true,
    hideToggle: true,
    showBetaButton: false,
  },
  supportContacts: [],
};

export default ChatOnYourWebsiteStrategy;
